import axios from "axios";
import { trackPromise } from "react-promise-tracker";
import { config_UPTIME } from "../Constants";
import {
  API_HEADER_SEARCH_REQUEST,
  API_REQUEST,
  API_REQUEST_CHATHISTORY,
  API_REQUEST_CREATE_MACHINE,
  API_REQUEST_JOINEDCHATROOMS,
  API_REQUEST_MACHINES,
  API_REQUEST_USERS,
  apiError,
  apiSuccess,
  apiSuccessCHATHISTORY,
  apiSuccessCREATEMACHINE,
  apiSuccessJOINEDCHATROOMS,
  apiSuccessMACHINES,
  apiSuccessSearchHeaderRequest,
  apiSuccessUSERS,
  API_REQUEST_COPILOT,
} from "../actions/api";
import { getalljoinrooms } from "../actions/chat";
import { getSingleMachine } from "../actions/machines";
import { getall } from "../actions/notification";
import {
  GetAllCategories,
  GetBrandsTypesEqs,
  GetEquipmentClasses,
  GetSingleEquipmentType,
  getallsitesareaeqs,
} from "../actions/objects";
import { setLoader } from "../actions/ui";
import { getUserByNodeId, getallaclusers } from "../actions/user";
import { getItem, setItem } from "../utils/DataProtection";
let authTokenRequest;

export const apiMiddleware = ({ dispatch }) => (next) => (action) => {
  next(action);

  if (action.type === API_REQUEST) {
    //dispatch(setLoader(true));
    const user_token = getItem("user");
    const { url, method, data, op } = action.meta;
    trackPromise(
      axios({
        method,
        url,
        data,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + JSON.parse(user_token),
        },
      })
        .then((response) => {
          if (
            op === "login" &&
            response.data?.accesstoken &&
            response.data?.userid &&
            response.data?.userinfo?.isReceiver === undefined
          ) {
            axios.post(
              `${config_UPTIME.url.API_URL}/userinfo/update`,
              {
                userid: response.data.userid,
                userinfo: {
                  isReceiver: true,
                },
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization:
                    "Bearer " + response.data.accesstoken,
                },
              }
            ).catch(() => {});
          }

          // console.log(response,"response");
          dispatch(apiSuccess({ response: response.data, op }))(
            op == "login"
              ? response.data.clientinfo == "machinebuilder"
                ? (dispatch(GetBrandsTypesEqs()),
                  dispatch(getUserByNodeId(response.data, "USER")),
                  dispatch(GetEquipmentClasses()))
                : (dispatch(setLoader({ state: false })),
                  // dispatch(getall('','ALLNOTIFICATIONS')),
                  /*  dispatch(getsitesareaeqs(response.data,'SAE')), */
                  dispatch(getUserByNodeId(response.data, "USER")),
                  dispatch(getallaclusers("ACL_USERS")),
                  dispatch(getalljoinrooms()),
                  dispatch(getallsitesareaeqs("", "ALL_SAE")))
              : op == "genericAttachment"
              ? dispatch(getSingleMachine(data.isattachmentof))
              : op == "ADDCATEGORY" ||
                op == "EDITCATEGORY" ||
                op == "DELETECATEGORY"
              ? dispatch(GetAllCategories("", "GETALLCATEGORIES"))
              : op == "genericAttachmentMB"
              ? dispatch(GetSingleEquipmentType(data.isattachmentof))
              : op == "noti_email"
              ? dispatch({
                  type: "EMAIL_SENT",
                  payload: true,
                })
              // : op === "GETUSER"
              // ? dispatch(getUserByNodeId({}, "USER"))
              : ""
          );

          if (op === "assignSAE") {
            dispatch({
              type: "SHOW_SNACKBAR",
              payload: {
                open: true,
                title: "Erfolg",
                description: "Zugewiesenes Equipment wurde gespeichert.",
                severity: "success",
              },
            });
          }
        })
        .catch((error) => {
          // A Meldung that can't be loaded (404 "Meldung nicht gefunden.",
          // or any other failed request) — the details page shows that
          // instead of its loading boxes forever.
          if (error?.isAxiosError && op === "GETSINGLENOTIFICATION") {
            dispatch({
              type: "NOTIFICATION_LOAD_FAILED",
              payload: {
                status: error.response?.status || 0,
                message: error.response?.data?.message || "",
              },
            });
          }
          // Only a request that really failed (an error status, or no
          // answer at all) — not an exception thrown after a successful one:
          // `dispatch(apiSuccess(...))(...)` above calls dispatch's result,
          // which is undefined, so it throws after EVERY success and lands
          // here although the answer was saved.
          if (
            error?.isAxiosError &&
            (op === "SUBMIT_CHECKLIST_REPORT" ||
              op === "SAVE_CHECKLIST_ITEM_ANSWER")
          ) {
            dispatch({
              type: "CHECKLIST_REPORT_SUBMIT_FAILED",
              payload: error.response?.data,
            });
          }
          // error,"error");
          // if (op === "assignSAE") {
          //   dispatch({
          //     type: "SHOW_SNACKBAR",
          //     payload: {
          //       open: true,
          //       title: "Fehler",
          //       description:
          //         "Zugewiesenes Equipment konnte nicht gespeichert werden.",
          //       severity: "error",
          //     },
          //   });
          // }
          // const status = error?.response?.status;
          // console.log(error, "SAQ_ERROR");
          // if (op === "GET_TAGS" && status === 304) {
          //   // Not modified is expected for cached GET requests.
          //   return;
          // }
          // dispatch(apiError({ error: error.response }));
          // if (op === "CREATE_TAG") {
          //   dispatch({
          //     type: "SHOW_SNACKBAR",
          //     payload: {
          //       title: "Tag",
          //       description: "Tag konnte nicht erstellt werden.",
          //       severity: "error",
          //     },
          //   });
          // } else if (op === "DELETE_TAG") {
          //   dispatch({
          //     type: "SHOW_SNACKBAR",
          //     payload: {
          //       title: "Tag",
          //       description: "Tag konnte nicht gelöscht werden.",
          //       severity: "error",
          //     },
          //   });
          // } else if (op === "GET_TAGS") {
          //   dispatch({
          //     type: "SHOW_SNACKBAR",
          //     payload: {
          //       title: "Tags",
          //       description: "Tags konnten nicht geladen werden.",
          //       severity: "error",
          //     },
          //   });
          // }
        })
    );
  }

  // if (action.type === API_REQUEST_COPILOT) {
  //   //dispatch(setLoader(true));
  //   const { url, method, data } = action.meta;
  //   trackPromise(
  //     axios({
  //       method,
  //       url,
  //       data,
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         'Allow': 'post'
  //       },

  //     })
  //       .then((response) => {
  //         dispatch(apiSuccess({response:response.data, op: API_REQUEST_COPILOT }))
  //       })
  //       .catch((error) => {
  //         console.log(error, "ERROR");
  //         /* dispatch(setLoader({state:false}))
  //       dispatch(apiError({ error: error.response })) */
  //         //((error.response.data.statusCode==500&&op=='ALLNOTIFICATIONS')?dispatch(getallOnce('','ALLNOTIFICATIONS')):'')
  //       })
  //   );
  // }

  if (action.type === API_REQUEST_CHATHISTORY) {
    //dispatch(setLoader(true));
    const user_token = getItem("user");
    const { url, method, data } = action.meta;
    trackPromise(
      axios({
        method,
        url,
        data,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + JSON.parse(user_token),
        },
      })
        .then(({ data }) => dispatch(apiSuccessCHATHISTORY({ response: data })))
        .catch((error) => {
          dispatch(apiError({ error: error.response }));
        })
    );
  }

  if (action.type === API_REQUEST_JOINEDCHATROOMS) {
    //dispatch(setLoader(true));
    const user_token = getItem("user");
    const { url, method, data } = action.meta;
    trackPromise(
      axios({
        method,
        url,
        data,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + JSON.parse(user_token),
        },
      })
        .then(({ data }) =>
          dispatch(apiSuccessJOINEDCHATROOMS({ response: data }))
        )
        .catch((error) => {
          dispatch(apiError({ error: error.response }));
        })
    );
  }

  if (action.type === API_REQUEST_MACHINES) {
    //dispatch(setLoader(true));
    const user_token = getItem("user");
    const { url, method, data } = action.meta;
    trackPromise(
      axios({
        method,
        url,
        data,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + JSON.parse(user_token),
        },
      })
        .then(({ data }) => dispatch(apiSuccessMACHINES({ response: data })))
        .catch((error) => {
          dispatch(apiError({ error: error.response }));
        })
    );
  }
  if (action.type === API_REQUEST_CREATE_MACHINE) {
    //dispatch(setLoader(true));
    const user_token = getItem("user");
    const { url, method, data } = action.meta;

    trackPromise(
      axios({
        method,
        url,
        data,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + JSON.parse(user_token),
        },
      })
        .then(({ data }) =>
          dispatch(apiSuccessCREATEMACHINE({ response: data }))
        )
        .catch((error) => {
          dispatch(apiError({ error: error.response }));
        })
    );
  }

  if (action.type === API_REQUEST_USERS) {
    //dispatch(setLoader(true));
    const user_token = getItem("user");
    const { url, method, data } = action.meta;
    trackPromise(
      axios({
        method,
        url,
        data,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + JSON.parse(user_token),
        },
      })
        .then(({ data }) => dispatch(apiSuccessUSERS({ response: data })))
        .catch((error) => {
          dispatch(apiError({ error: error.response }));
        })
    );
  }

  if (action.type === API_HEADER_SEARCH_REQUEST) {
    // alert("header search")
    dispatch(setLoader({ state: true }));
    const user_token = getItem("user");
    const { url, method, data } = action.meta;
    trackPromise(
      axios({
        method,
        url,
        data,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + JSON.parse(user_token),
        },
      })
        .then(({ data }) => {
          dispatch(apiSuccessSearchHeaderRequest({ response: data }));
        })
        .catch((error) => {
          dispatch(setLoader({ state: false }));
          dispatch(apiError({ error: error.response }));
        })
    );
  }

  /**
 * @description this method calls a requestNewToken method to issue a 
 new token to the client
*/

  function getAuthToken() {
    if (!authTokenRequest) {
      authTokenRequest = requestNewToken();
      authTokenRequest.then(resetAuthTokenRequest, resetAuthTokenRequest);
    }
    return authTokenRequest;
  }

  function resetAuthTokenRequest() {
    authTokenRequest = null;
  }

  function requestNewToken() {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const response = axios
      .post(
        config_UPTIME.url.API_URL + "/object/refresh-token",
        { token: JSON.parse(getItem("refreshToken")) },
        config
      )
      .then((res) => {
        setItem("user", JSON.stringify(res.data.accesstoken));
        setItem("refreshToken", JSON.stringify(res.data.refreshtoken));
      })
      .catch((error) => {});

    return response;
  }

  axios.interceptors.response.use(undefined, (err) => {
    console.log(err, "MAIN ERROR");
    //console.log('errr->'+err)
    const error = err.response;
    // if error is 401
    if (
      error.status === 401 &&
      error.config &&
      !error.config.__isRetryRequest
    ) {
      // request for a new token
      return getAuthToken().then((response) => {
        // update the error config with new token
        error.config.__isRetryRequest = true;
        err.config.headers.Authorization = `Bearer ${JSON.parse(
          getItem("user")
        )}`;
        return axios(error.config);
      });
    }
    // if error is 500
    const usernodeid = getItem("usernodeid");

    if (error.status === 500 && usernodeid != undefined) {
      //dispatch(getallOnce('','ALLNOTIFICATIONS'))
    }
  });
};
